<div class="row">
  <div class="prepayContractOuter">
    <div class="prepayContractTop">
      <div class="prepayContract">
        <div class="order-view-sec breadcrumbOuter padding-0 col-md-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item ">
                <a href="javascript:void(0)" (click)="navigateToPrePay()">Contracts</a>
                <i class="fas fa-angle-right"></i>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Contract: {{contractData.contractId}}
              </li>
            </ol>
          </nav>
        </div>

        <div class="row contract-info">
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-sm-4 padding-l0 text-right">CONTRACT #:</div>
                  <div class="col-sm-8 padding-l0" *ngIf="transaction.contractNo > 0"> <span>{{transaction.contractNo}}</span></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-sm-4 text-right">ACCOUNT:</div>
                  <div class="col-sm-8 padding-l0">
                    <div>
                      <span> {{transaction.account}}</span><br>
                      <span> {{transaction.address}}</span><br>
                      <span> Account #: {{transaction.accountNo}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-sm-5 text-right">PARENT ACCOUNT:</div>
                  <div class="col-sm-7 padding-l0">
                    <span>{{transaction.parentAccount}}</span><br>
                    <span>{{transaction.parentAccountAddress}}</span><br>
                    <span>Account #: {{transaction.parentAccountNo}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <table>

                  <tbody class="currentBalBlock">
                    <tr class="currentBalHead">
                      <td class="text-left">CONTRACT TYPE</td>
                      <td class="text-left">{{contractData.contractType}}</td>
                    </tr>
                    <tr class="currentBalHead">
                      <td class="text-left">CONTRACT DESCRIPTION</td>
                      <td class="text-left">{{contractData.contractDescription}}</td>
                    </tr>
                    <tr class="currentBalHead">
                      <td class="text-left">
                        CURRENT BALANCE:
                      </td>
                      <td class="text-left">
                        <span *ngIf="contractData !== undefined && contractData.currentBalance < 0"> $({{ contractData.currentBalance | number  : '1.2-2' }})</span>
                        <span *ngIf="contractData !== undefined && contractData.currentBalance >= 0"> ${{ contractData.currentBalance | number  : '1.2-2' }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        <span>
                          REQUESTED AMOUNT:
                        </span>
                      </td>
                      <td class="text-left">
                        <span *ngIf="contractData !== undefined && contractData.requestedAmount < 0">
                          $({{ contractData.requestedAmount |positiveValue| number  : '1.2-2' }})
                        </span>
                        <span *ngIf="contractData !== undefined && contractData.requestedAmount >= 0">
                          ${{ contractData.requestedAmount | number  : '1.2-2' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="prepayContBottom">
      <div class="prepayContract margin-t20">
        <div class="row prepayDateFilter">
          <div class="col-md-8">
            <div class="dateCal">
              <label>Date Range: </label>
              <span>
                <mat-form-field class="wide100">
                  <input matInput [readonly]="true" [matDatepicker]="picker" (dateChange)="validateDateFilter('fromDate', $event)" placeholder="From Date" [(ngModel)]="fromDate" (focus)="picker.open();" [matDatepickerFilter]="fromDateFilter">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </span>
              <span>
                <mat-form-field class="wide100">
                  <input matInput [readonly]="true" [matDatepicker]="picker1" (dateChange)="validateDateFilter('toDate', $event)" placeholder="To Date" [(ngModel)]="toDate" (focus)="picker1.open();" [matDatepickerFilter]="toDateFilter">
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </span>
            </div>
          </div>
          <div class="col-md-4 text-right exportBlockOuter" *ngIf="showExport">
            <label class="text">
              Export Ledger
            </label>
            <span class="exportBlock" [matMenuTriggerFor]="beforeMenu">
              <small class="roundBtn">
                <i class="fas fa-arrow-down"></i>
              </small>
            </span>
            <mat-menu #beforeMenu="matMenu" xPosition="before" class="context-meun-dropdown">
              <button mat-menu-item (click)="generatePdf()" [disabled]="">Download Pdf</button>
              <button mat-menu-item (click)="exportData()">Download Excel</button>
            </mat-menu>
          </div>
        </div>
        <div>
          <div class="prepayContractPaging">
            <div class="row listing-action-items">
              <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0">
                &nbsp;
              </div>
              <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10">
                <mat-paginator #contractsPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
              </div>
            </div>
          </div>
          <div class="tableContainer prepayContractTable">
            <table mat-table #contractsTable [dataSource]="contractsDataSource" matSort #contractsSort matSortDirection="desc" class="matTables">

              <ng-container matColumnDef="transactionDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipTo transactionDate">Transaction Date</th>
                <td mat-cell *matCellDef="let element">
                  {{element.transactionDate | date:'MM/dd/yyyy' }}
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <ng-container matColumnDef="transaction">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="transactionNo">Transaction #</th>
                <td mat-cell *matCellDef="let element">
                  {{element.transaction}}
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="contractNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="transactionNo">Contract Number</th>
                <td mat-cell *matCellDef="let element">
                  {{element.contractNo}}
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="description">Description</th>
                <td mat-cell *matCellDef="let element">
                  {{element.description}}
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <ng-container matColumnDef="transactionAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="transactionAmt text-center">Transaction Amount</th>
                <td mat-cell *matCellDef="let element" class="text-right padding-r25">
                  <div *ngIf="element.transactionAmount < 0">
                    $({{ element?.transactionAmount |positiveValue| number  : '1.2-2' }})
                  </div>
                  <div *ngIf="element.transactionAmount >= 0">
                    ${{ element?.transactionAmount | number  : '1.2-2' }}
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <ng-container matColumnDef="previousBalance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="prevBal text-center">Previous</th>
                <td mat-cell *matCellDef="let element" class="text-right padding-r25">
                  <div *ngIf="element.previousBalance < 0">
                    $({{ element?.previousBalance |positiveValue| number  : '1.2-2' }})
                  </div>
                  <div *ngIf="element.previousBalance >= 0">
                    ${{ element?.previousBalance | number  : '1.2-2' }}
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="currentBalance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="currentBal text-center">Current</th>
                <td mat-cell *matCellDef="let element" class="text-right padding-r25">
                  <div *ngIf="element.currentBalance < 0">
                    $({{ element?.currentBalance |positiveValue| number  : '1.2-2' }})
                  </div>
                  <div *ngIf="element.currentBalance >= 0">
                    ${{ element?.currentBalance | number  : '1.2-2'}}
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef> {{getTotalTransactions()| number }} Transactions</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="contractsColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: contractsColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="contractsFooterColumns; sticky: true"></tr>
            </table>
            <div *ngIf="transaction == undefined || transaction.transactionsList == undefined|| transaction.transactionsList.length == 0" class="noDataMsg whiteBg">
              <p>No Record Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prepayBtnSec">
      <div class="row">
        <div class="col-md-12">
          <button mat-raised-button class="btns" (click)="navigateToPrePay()">Go Back</button>
        </div>
      </div>
    </div>
  </div>
</div>
